import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const TimelineCaptionReorderAndScrubContent = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 30) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={(222 / 30) * fps}
			style={{
				width: 2084,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio-close-ups/caption-position-and-playhead-scrub-988a0436c211.mp4"
				durationInFrames={(222 / 30) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[3, 13, 14, 15, 16, 26, 77, 78, 79, 80, 81],
					[
						'auto',
						'ns-resize',
						'auto',
						'ns-resize',
						'auto',
						'default',
						'ns-resize',
						'auto',
						'default',
						'row-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 21, 74, 102, 166, 193, 197],
						[
							1.8774063435800281, 1.6896657092220253, 1.8774063435800281,
							1.6896657092220253, 1.8774063435800281, 1.6896657092220253,
							1.8774063435800281,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
							22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
							40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
							56, 57, 58, 59, 60, 61, 62, 76, 77, 78, 79, 80, 81, 82, 84, 85,
							86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101,
							102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114,
							115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
							128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140,
							141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153,
							154, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179,
							180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191,
						],
						[
							'617.2266699260526px 1590.515186701705px',
							'729.4530342846666px 1469.2538043146121px',
							'916.130293955876px 1221.03281794292px',
							'972.6064902523987px 1063.5946953492635px',
							'981.3041618285156px 1022.3577583572694px',
							'982.7342174417894px 1011.3279960887368px',
							'982.6242131638453px 1009.6485974454562px',
							'980.3214569455479px 1003.5250259732323px',
							'974.3372242253865px 994.5413432744607px',
							'960.9680376459085px 979.0307400843366px',
							'944.2473873983988px 962.1927519403532px',
							'935.4617123999267px 952.7910529853939px',
							'925.9940108782008px 941.0499297194891px',
							'915.4702682882112px 929.8808286988939px',
							'905.5918841288272px 921.4618346269021px',
							'900.6270243842816px 917.4063435800281px',
							'897.6789097353786px 915.2795942064414px',
							'897.5542382203753px 915.2135916396749px',
							'897.5542382203753px 915.2135916396749px',
							'897.1435555827171px 914.8029090020167px',
							'895.9555093809204px 909.596039845994px',
							'895.4714905579661px 899.9743323351464px',
							'895.6401637841471px 849.2916946770152px',
							'894.1514392226364px 810.0421683065452px',
							'890.8953125954898px 776.4395282038746px',
							'889.5312595489825px 754.1379942553322px',
							'888.7832304589623px 735.7526126016012px',
							'888.5412210474852px 720.6013567194279px',
							'888.5412210474852px 710.9649819715211px',
							'888.5412210474852px 703.2060135671943px',
							'888.7758968404327px 698.2044857300006px',
							'888.7758968404327px 696.657092220253px',
							'888.7758968404327px 695.3223736478641px',
							'888.7758968404327px 695.1096987105054px',
							'888.7758968404327px 695.1096987105054px',
							'888.9739045407322px 695.7110554299334px',
							'889.8832732384037px 710.6569699932775px',
							'890.3379575872395px 739.0967426511031px',
							'890.3379575872395px 765.6004400171117px',
							'890.0006111348774px 790.8647558516165px',
							'889.2085803336796px 812.5869339363197px',
							'888.5338874289556px 827.9948664670293px',
							'887.7931919574651px 844.4588400660026px',
							'887.3385076086292px 856.6106459695654px',
							'886.2971337774247px 867.4864022489763px',
							'886.0184562732995px 875.8907290839088px',
							'885.8057813359409px 881.3249404143495px',
							'885.5417710688749px 885.0357513903318px',
							'885.3364297500458px 889.1572450039723px',
							'885.2850944203386px 893.5720833587973px',
							'885.2850944203386px 897.46623479802px',
							'885.2850944203386px 902.0937480902035px',
							'885.1237548126871px 905.481879850883px',
							'885.1237548126871px 908.2173195624274px',
							'885.1237548126871px 909.0973537859805px',
							'885.1237548126871px 909.3466968159873px',
							'885.1237548126871px 909.4933691865795px',
							'885.1237548126871px 909.4933691865795px',
							'860.0427794414227px 940.5659108965349px',
							'795.4042657214447px 1026.7505958565055px',
							'754.9006905824116px 1130.3379575872395px',
							'728.0669803825705px 1186.0734584122715px',
							'690.7388620668581px 1287.7760801808959px',
							'686.6540365458657px 1306.4548065758113px',
							'686.6540365458657px 1306.4548065758113px',
							'681.4765018639614px 1300.2432316812321px',
							'657.4955692721384px 1284.4392837499236px',
							'640.0708916457862px 1279.5257593350852px',
							'618.1873739534316px 1277.897696021512px',
							'605.8155594939803px 1277.2890056835543px',
							'593.9570983316017px 1275.9616207296951px',
							'586.6748151316996px 1273.1895129255026px',
							'581.709955387154px 1268.2026523253683px',
							'578.5051640897146px 1253.8947625741px',
							'577.2364480840921px 1246.8764896412638px',
							'575.8577278005256px 1228.3957709466479px',
							'572.39625985455px 1219.0087392287478px',
							'570.0495019250749px 1216.4859744545622px',
							'566.5660331235104px 1214.8139094298112px',
							'560.6478029701155px 1214.102548432439px',
							'556.9223247570739px 1214.102548432439px',
							'556.9003239014851px 1214.102548432439px',
							'556.8049868606001px 1214.102548432439px',
							'556.8049868606001px 1214.102548432439px',
							'559.4377559127299px 1214.8359102854px',
							'577.4711238770396px 1217.8353602640102px',
							'610.9417588461773px 1220.3214569455479px',
							'640.5622440872701px 1222.125527103832px',
							'663.5458045590661px 1222.873556193852px',
							'685.2459817881806px 1223.137566460918px',
							'703.4113548860233px 1223.7315895618162px',
							'720.8873678420828px 1223.797592128583px',
							'737.3293405854672px 1223.9222636435861px',
							'759.3008617001773px 1224.582289311251px',
							'775.9481757623907px 1225.520992483041px',
							'795.3602640102671px 1226.7163723033673px',
							'818.6078347491291px 1228.2564321945854px',
							'839.0099614985028px 1229.2464706960827px',
							'866.4816965104199px 1230.7205280205342px',
							'894.0927702743995px 1232.1432500152785px',
							'916.3429688932347px 1233.4779685876672px',
							'930.7388620668581px 1234.292000244454px',
							'948.2295422599768px 1235.0326957159446px',
							'965.896229297806px 1236.1034040212676px',
							'982.9908940903257px 1236.9614373892318px',
							'1011.7460123449246px 1238.9268471551673px',
							'1034.6049013017173px 1240.488907901974px',
							'1055.791725233759px 1241.405610218175px',
							'1075.1451445333985px 1241.8749618040702px',
							'1101.5241703844038px 1243.1950131393999px',
							'1125.1164211941575px 1244.6984049379698px',
							'1136.9675487380064px 1245.2924280388681px',
							'1161.31516225631px 1246.57581128155px',
							'1179.1211880462017px 1247.925197090998px',
							'1194.609790380737px 1248.82723217014px',
							'1210.5457434455784px 1250.2572877834139px',
							'1224.750962537432px 1251.379331418444px',
							'1242.1463056896657px 1252.8900568355436px',
							'1264.1251604229053px 1254.063435800281px',
							'1285.2973171178878px 1255.229481146489px',
							'1301.3872761718512px 1256.7255393265293px',
							'1317.821915296706px 1257.8915846727373px',
							'1333.3545193424188px 1259.3656419971887px',
							'1347.22972560044px 1260.2163417466236px',
							'1362.4616512864388px 1261.2503819592985px',
							'1379.6149850271954px 1262.2770885534437px',
							'1399.342418871845px 1263.9564871967243px',
							'1416.884434394671px 1265.4598789952943px',
							'1430.6129682821px 1266.7285950009168px',
							'1443.7108109759824px 1268.0633135733055px',
							'1450.963759701766px 1268.8186762818555px',
							'1457.4393448634114px 1269.3393631974577px',
							'1460.4021267493736px 1269.4347002383427px',
							'1461.0254843243904px 1269.4933691865795px',
							'1461.4581678176373px 1269.4933691865795px',
							'1461.4581678176373px 1269.4933691865795px',
							'1460.4754629346696px 1269.764713072175px',
							'1446.5269204913525px 1271.2607712522154px',
							'1380.810364847522px 1301.7392898612725px',
							'1243.9357086108905px 1382.761107376398px',
							'1048.6121126932715px 1526.0526798264377px',
							'960.3153455967732px 1581.876184073825px',
							'905.2912057691133px 1605.725111532115px',
							'872.4439283749923px 1613.14673348408px',
							'846.6589256248855px 1618.287600073336px',
							'806.9400476685205px 1627.6746317912364px',
							'769.032573488969px 1636.0569577705799px',
							'744.5896229297806px 1638.30837865917px',
							'705.127421621952px 1638.909735378598px',
							'666.5965898673837px 1637.3843427244392px',
							'635.0253620974149px 1636.1229603373465px',
							'610.179062519098px 1635.9102853999877px',
							'596.2378536943104px 1635.9102853999877px',
							'586.6748151316996px 1636.2916335635275px',
							'582.986005011306px 1637.3990099614985px',
							'577.427122165862px 1640.2151194768685px',
							'574.4203385687222px 1641.6378414716128px',
							'572.9242803886818px 1642.6425472101694px',
							'572.6676037401454px 1642.7672187251726px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const TimelineCaptionReorderAndScrubComposition = Interactive.create({
	Component: TimelineCaptionReorderAndScrubContent,
	layout: 'absolute-fill',
	schema: {},
});
